import { render } from "./CommonModal.vue?vue&type=template&id=2352dabf&scoped=true&ts=true"
import script from "./CommonModal.vue?vue&type=script&lang=ts"
export * from "./CommonModal.vue?vue&type=script&lang=ts"

import "./CommonModal.vue?vue&type=style&index=0&id=2352dabf&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2352dabf"]])

export default __exports__